var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 18H0V16.4885H18V18ZM7.26316 14.5739V10.7447L10.5263 12.6593L7.26316 14.5739ZM1.05263 14.5739V10.7447L4.31579 12.6593L1.05263 14.5739ZM13.4737 14.5739V10.7447L16.7368 12.6593L13.4737 14.5739ZM18 8.83013H0V7.31861H1.68421V2.38099C1.68421 2.38099 1.68421 2.38099 1.68421 2.28022C1.68421 1.87715 1.89474 1.37331 2.73684 0.97024C5.26316 -0.339741 13.2632 -0.339741 15.5789 1.07101C16.3158 1.47408 16.5263 2.07869 16.4211 2.38099V7.31861H18V8.83013ZM3.26316 7.31861H14.8421V3.69097C14.7368 3.69097 14.7368 3.69097 14.6316 3.79174C12.3158 4.49711 6.10526 4.79942 3.15789 3.79174V7.31861H3.26316ZM3.57895 2.28022C4.52632 2.58253 6.63158 2.9856 9.47368 2.88483C12 2.88483 13.7895 2.48176 14.5263 2.17945C13.6842 1.87715 11.7895 1.57485 8.94737 1.57485C6.10526 1.57485 4.31579 1.97792 3.57895 2.28022Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowIcon);
export default __webpack_public_path__ + "static/media/flowIcon.219f293c36a66f5d453fc2be0916e9d3.svg";
export { ForwardRef as ReactComponent };